export default __webpack_public_path__ + "static/media/bandolier.1d7c923a.png";